import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder'
  },
  table: {
    minWidth: 200,
    overflowX: 'auto'
  },
  progress: {
    margin: UNIT * 3,
    color: mainColor.secondaryColor
  },
  hrStyle: {
    border: '0',
    height: '1px',
    backgroundImage:
      'linear-gradient(to right, rgba(200, 200, 200, 0.5), rgba(200, 200, 200, 0.75), rgba(200, 200, 200, 0.5))'
  },
  cookingStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cookingDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  margeDetail: {
    flexBasis: '2.5%',
    flexShrink: 0
  },
  detail: {
    fontSize: UNIT * 0.75
  },
  subtitle: {
    fontSize: UNIT,
    fontWeight: 'bolder',
    marginBottom: UNIT * 1.25
  },
  title: {
    fontSize: UNIT * 0.75,
    color: mainColor.colorBlack,
    fontWeight: 'bolder',
    marginRight: UNIT * 0.3125
  },
  orderDetail: {
    fontSize: UNIT,
    display: 'flex',
    color: mainColor.colorBlack
  },
  textDetails: {
    fontSize: UNIT * 0.75,
    margin: '5px 0px 5px 0px',
    marginLeft: UNIT * 0.625
  },
  textUndelined: {
    fontSize: UNIT * 0.75,
    fontWeight: 'bolder',
    textDecoration: 'underline'
  },
  textTitle: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bolder'
  },
  dynMarg: {
    flexBasis: '100%'
  },
  boldText: {
    fontSize: UNIT * 1.125,
    margin: '-1px 0px 0px 5px'
  },
  totalStyle: {
    fontSize: UNIT * 0.8125,
    color: mainColor.colorBlack,
    fontWeight: 'bolder',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  labelStyle: {
    color: mainColor.colorBlack,
    fontWeight: 'bolder',
    width: '85%',
    display: 'flex',
    flexDirection: 'row',
  },
  orderDetailStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  rowStyle: {
    display: 'flex',
    flexDirection: 'row'
  },
  iconStyle: {
    border: '1px solid rgb(200, 200 ,200)',
    borderRadius: UNIT * 0.625,
    maxWidth: UNIT * 3.125
  },
  loadingStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center'
  },
  textDecoration: {
    color: mainColor.colorBlack
  },
  itemsStyle: {
    flexDirection: 'column',
    justifyContent: 'center',
    display: 'grid'
  },
  paperStyle: {
    padding: UNIT * 1.25,
    border: '1px solid #B5B3B3',
    height: '100%'
  },
  paper: {
    padding: UNIT * 1.25,
    border: '1px solid #B5B3B3'
  },
  secondSectionStyle: {
    padding: '20px 10px 15px 20px',
    border: '1px solid #B5B3B3'
  },
  listItemIcon: {
    fontSize: UNIT
  },
  paymentSection: {
    marginTop: UNIT * 0.9375,
    display: 'flex',
    padding: UNIT * 0.9375,
    paddingLeft: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid #8B8989'
  },
  fromDashboardBtn: {
    fontSize: UNIT * 0.9375,
    borderWidth: '2px'
  },
  centeBtn: {
    textAlign: 'center',
    margin: UNIT * 0.625
  },
  searchDriver: {
    fontSize: UNIT * 1.2,
    height: '100%',
    fontWeight: 'bolder'
  },
  spinner: {
    color: mainColor.colorWhite,
    height: 'fit-content',
    width: 'fit-content',
    marginLeft: '10px'
  },
  deliveryIcon: {
    marginBottom: UNIT * 0.3,
    fontSize: UNIT * 1.125
  },
  dateStyle: {
    width: `${UNIT * 8.625}%`
  },
  deliverySectionStyle: {
    border: '1px solid #B5B3B3',
    padding: '15px 20px 15px 20px',
    marginTop: UNIT * 0.9375
  },
  deliveryStyle: {
    border: '1px solid #8B8989',
    marginTop: UNIT,
    padding: UNIT
  },
  deliverySecondSectionStyle: {
    padding: '20px 10px',
    border: '1px solid #B5B3B3'
  },
  spinnerStyle: {
    paddingBottom: UNIT * 4.25,
    paddingTop: UNIT * 3.9375
  },
  disableStyle: {
    pointerEvents: 'none'
  },
  message: {
    width: '100%',
    height: '100%',
    fontWeight: 'bolder',
    fontSize: UNIT * 0.9125
  },
  animatedLogo: {
    animation: '$blink 2s ease-in-out infinite',
    animationDelay: '0.5s',
    borderRadius: UNIT * 0.25,
    width: UNIT * 1.3125,
    height: UNIT * 1.3125,
  },
  '@keyframes blink': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0 },
    '100%': { opacity: 1 },
  },


  logo: {
    borderRadius: UNIT * 0.25,
    width: UNIT * 1.3125,
    height: UNIT * 1.3125
  },
  followLink: {
    textDecoration: 'underline',
    color: '#009973',
    cursor: 'pointer',
    fontSize: UNIT * 0.875,
    '&:hover': {
      textDecoration: 'underline',
      color: '#009973',
    }
  },
  driverLogo: {
    borderRadius: UNIT * 0.25,
    width: UNIT * 1.5625,
    height: UNIT * 1.5625,
    marginLeft: UNIT * 0.25
  },
  caisseContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  caisseLogo: {
    borderRadius: UNIT * 0.25,
    width: UNIT * 4.375,
    height: UNIT * 4.375
  },
  arrow: {
    transform: 'translate(-50%, 0)',
    width: UNIT * 1.875,
    height: UNIT * 1.875,
    animation: '$arrowAnimation 1s ease-in-out infinite'
  },
  '@keyframes arrowAnimation': {
    '0%': {
      transform: 'translateY(-10px)'
    },
    '50%': {
      transform: 'translateY(5px)'
    },
    '100%': {
      transform: 'translateY(-10px)'
    }
  },
  loyalty: {
    border: `1px solid ${mainColor.secondaryColor}`,
    borderRadius: UNIT * 2,
    marginLeft: 10,
    paddingRight: 4,
    paddingLeft: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: mainColor.secondaryColor,
    color: 'white'
  },
  lookingDriverStyle: {
    border: '1px solid #B5B3B3',
    padding: UNIT
  },
  driverTitle: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bolder',
    width: 230
  },
});
